import { AHText } from "arkh";
import React from "react";
import { PILL_INDICATOR_SIZE } from "../PillIndicator";

export function StoresIndicator(props: {
  totalStores: number;
  value: number;
  status: "ACTIVE" | "INACTIVE";
}) {
  return (
    <AHText
      color={props.status === "ACTIVE" ? "positive" : "washedText"}
      type="detail"
      textAlign="right"
      style={{ width: PILL_INDICATOR_SIZE.width }}
    >
      {props.value} / {props.totalStores}
    </AHText>
  );
}
